import { ValueRequirement } from "@kase/my-marathon-communication";
import { store } from "~/core/store";
import { ExpenseReceipt } from "../expense/interfaces";

export const getReceiptConfig = (receipt: ExpenseReceipt) => {
    const { api } = store;
    const expenseType = api.expense.getType(receipt.expense_type);
    const baseCurrency = api.currency.base.value;
    const isOtherCur = !baseCurrency?._id.equals(receipt.currency);
    const vatMandatory =
        api.settings.book.store.value.registration.vat_mandatory_expense;
    const enterPurchaseCode =
        api.settings.book.store.value.registration.purchase_code_in_expense;
    const showCompanyCard =
        api.me.loaded.value && api.me.user.value?.company_card;

    return {
        vat: !vatMandatory
            ? ValueRequirement.Forbidden
            : isOtherCur || expenseType?.vat
              ? ValueRequirement.Forbidden
              : ValueRequirement.Required,
        comment: expenseType?.comment ?? ValueRequirement.Allowed,
        quantity: expenseType?.priceperunit ?? ValueRequirement.Allowed,
        project: expenseType?.project ?? ValueRequirement.Allowed,
        purchase_code: !enterPurchaseCode
            ? ValueRequirement.Forbidden
            : (expenseType?.purchase_code ?? ValueRequirement.Allowed),
        companyCard: showCompanyCard
            ? ValueRequirement.Required
            : ValueRequirement.Forbidden,
    };
};
